module.exports = __webpack_public_path__ + "static/media/check-ico.6c47b210.svg";